import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";

/**
 * Replicates 'create' command: create <title> <chartType> [parentId]
 */
export async function createNode(title, chartType, parentId = null) {
  return await getAPIResponse("/v1/orgChart/node", {
    title,
    chartType,
    parentId
  }, "POST");
}

/**
 * Replicates 'update' command: update <nodeId> <newTitle>
 */
export async function updateNode(nodeId, title) {
  return await getAPIResponse(`/v1/orgChart/node/${nodeId}`, {
    title
  }, "PATCH");
}

/**
 * Replicates 'delete' command: delete <nodeId>
 */
export async function deleteNode(nodeId) {
  return await getAPIResponse(`/v1/orgChart/node/${nodeId}`, null, "DELETE");
}

/**
 * Replicates 'reassign' command: reassign <nodeId> <newParentId>
 */
export async function reassignNode(nodeId, newParentId, options = {}) {
  return await getAPIResponse(`/v1/orgChart/node/${nodeId}`, {
    parentId: newParentId,
    ...(options.detachFromGeneral === true ? { detachFromGeneral: true } : {}),
  }, "PATCH");
}

/**
 * Replicates 'assign-position' command: assign-position <nodeId> <positionId>
 */
export async function assignPosition(nodeId, positionId) {
  return await getAPIResponse(`/v1/orgChart/node/${nodeId}`, {
    positionId
  }, "PATCH");
}

/**
 * Replicates 'assign-employee' command: assign-employee <nodeId> <employeeId>
 */
export async function assignEmployee(nodeId, employeeId) {
  return await getAPIResponse(`/v1/orgChart/node/${nodeId}`, {
    userId: employeeId
  }, "PATCH");
}

/**
 * Renames an entire org chart structure
 */
export async function renameChartType(oldType, newType) {
  return await getAPIResponse(`/v1/orgChart/chart-type/${encodeURIComponent(oldType)}`, {
    newType
  }, "PATCH");
}

/**
 * Deletes an entire org chart structure
 */
export async function deleteChartType(type) {
  return await getAPIResponse(`/v1/orgChart/chart-type/${encodeURIComponent(type)}`, null, "DELETE");
}
